import { render } from "./modalSubscription.vue?vue&type=template&id=0428f788"
import script from "./modalSubscription.vue?vue&type=script&lang=js"
export * from "./modalSubscription.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__